import axios from 'axios'
import store from '@/globalvar.js'
import router from '@/router'

// Esto puedo necesitarlo cuando implemente el login
// import { StorageService } from '../services/storage.service'

import StorageService from '@/services/storage.service'

//let timeout = null;
let pendingRequests = 0;
let failSafe = null;

function getFailSafeTime() {  
  return window.APP_CONFIG?.loaderFailSafeMs || 30000;
}

function startLoading() {
      pendingRequests++
      store.commit('SET_LOADING', true);
       if (!failSafe) {
          failSafe = setTimeout(() => {
            pendingRequests = 0;
            store.commit('SET_LOADING', false);
            failSafe = null;
          }, getFailSafeTime())
        }
    }
   function endLoading() {
      if (pendingRequests > 0) pendingRequests--;

      if (pendingRequests === 0) {
        store.commit('SET_LOADING', false);

        if (failSafe) {
          clearTimeout(failSafe);
          failSafe = null;
        }
      }
    }

   function ResetLoading(){     
      pendingRequests = 0;
      store.commit('SET_LOADING', false);

      if (failSafe) {
        clearTimeout(failSafe);
        failSafe = null;
      }
    }

const ApiService = {
  APIURL: '', 
  init(baseURL) {
    this.APIURL = baseURL
    axios.defaults.baseURL = baseURL;
    store.commit('setApiUrl',baseURL);    
    
    axios.interceptors.request.use(config => {
      if (!config.DisableLoading) {
        startLoading();
      }
      var token = StorageService.getOnlyToken();
      if (token) {
          config.headers.Authorization = `Bearer ${token}`;
      }  
      const routeName = window?.appVueRouter?.currentRoute?.value?.name || (window.location.pathname);
      if (routeName) {
        config.headers['X-View-Name'] = routeName;
      }      
      return config;
    },
      error => {
        endLoading()
        return Promise.reject(error)
      }
  );
  


   axios.interceptors.response.use(response => {
    endLoading();
      return response;
    }, error => {
      endLoading();
      if(error.response && 401 === error.response.status) {        
        if (error.response.data && error.response.data.errorMessage == "Select Provider") {
          ResetLoading(); 
          router.push('/provider');              
        } else {
          var uname = StorageService.getName();
          if ( uname == null ) {
            uname = "user";
          }
          ResetLoading();
          router.push('/unauthorized?u='+uname);
          store.commit('setAccessToken','');
          localStorage.removeItem("vuex");
          localStorage.removeItem("_secure__ls__metadata");                         
        }        
        return error.response.statusText;
      }    
      return Promise.reject(error);          
    });
  },

 

    setHeader() {

    },

    removeHeader() {
        axios.defaults.headers.common = {}
    },

    get(resource) { 
        return axios.get(resource,{
            headers: {}
          })
    },

    getData(resource, data) { 
        return axios.get(resource, data)
    },

    post(resource, data) {
        return axios.post(resource,data,{
          headers: {}
        })
    },

    put(resource, data) {
        return axios.put(resource, data,{
          headers: {}
        })
    },

    delete(resource, data) {
        return axios.delete(resource, { data: data },{
            headers: {}
          })
    },

      /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    customRequest(data) {
        var result = axios(data);
        return result;
    },

    parseParams(params) {
      const keys = Object.keys(params)
      let options = ''
    
      keys.forEach((key) => {
        const isParamTypeObject = typeof params[key] === 'object'
        const isParamTypeArray = isParamTypeObject && params[key] && params[key].length >= 0
    
        if (!isParamTypeObject) {
          options += `${key}=${params[key]}&`
        }
    
        if (isParamTypeObject && isParamTypeArray) {
          params[key].forEach((element) => {
            options += `${key}=${element}&`
          })
        }
      })    
      return options ? options.slice(0, -1) : options
    },

    getWithArray(resource,data) {     
      return axios.get(resource, {
        params: data,
          paramsSerializer: (params) => this.parseParams(params)
        }
      )
    },
}

export default ApiService